console.log("current environment", "production");

export const appConfig = {
  api: {
    apiUrl: 'https://edesignapi.carrier.com/prod/api',
    umDashboardNavigation: 'https://www.carrierappshub.com/'
  },
  uiUrl: 'https://edesign.carrier.com/licenseManager',
  apiUrl: 'https://api.carrierappshub1.com/',
  postLogOutUri: 'https://edesign.carrier.com/licenseManager'
};
export default appConfig;
